
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useStore } from '@/plugins/store/index';
import GenericTable from '@/components/tables/GenericTable.vue';
import { MyBody, MyBodyStatistics } from '@/types';

export default defineComponent({
    components: { GenericTable },
    data() {
        function cellRendererSelector(params: any) {
            if (params.node.rowPinned) {
                return {
                    component: 'CustomPinnedRowCellRenderer',
                };
            }
            if (params.colDef.field === 'icon') {
                return {
                    component: 'IconCellRenderer',
                };
            }
            return {
                component: 'GenericCellRenderer',
            };
        }
        return {
            headers: [
                {
                    width: 8,
                    headerName: '',
                    field: 'icon',
                    sortable: true,
                    cellRendererSelector,
                },
                {
                    headerName: 'Min krop',
                    field: 'title',
                    sortable: true,
                    cellRendererSelector,
                },
                {
                    headerName: 'Antal',
                    field: 'amount',
                    sortable: true,
                    cellRendererSelector,
                },
            ],
        };
    },
    computed: {
        ...mapState(useStore, ['myBodyStatistics', 'myBodies']),
        pinnedBottomRowData(): any {
            return [
                {
                    icon: null,
                    title: 'Total',
                    amount: this.items.reduce((accum, current) => {
                        return accum + current.amount;
                    }, 0),
                },
            ];
        },
        items(): any[] {
            if (!this.myBodyStatistics || !this.myBodies) {
                return [];
            }
            return [
                ...this.myBodies.map((myBody: MyBody) => {
                    return {
                        icon: myBody.iconUrl,
                        title: myBody.title,
                        amount: this.myBodyStatistics.filter((statistic: MyBodyStatistics) => statistic.ref === myBody.id || statistic.refs?.includes(myBody.id)).length,
                    };
                }),
            ];
        },
    },
});
